<template>
    <div>
        <SkeletonBase
            class="hidden md:block"
            has-title
            :table="5"
            has-button
        />
        <SkeletonBase
            class="md:hidden"
            has-title
            :content="10"
            has-button
        />
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase
    },
};
</script>
